.notifications-wrapper {
  display: flex;
  gap: 8px;
  padding-top: 28px;
}
